import { render, staticRenderFns } from "./SiteAutoAnswers.vue?vue&type=template&id=09489c89"
import script from "./SiteAutoAnswers.vue?vue&type=script&lang=js"
export * from "./SiteAutoAnswers.vue?vue&type=script&lang=js"
import style0 from "./SiteAutoAnswers.vue?vue&type=style&index=0&id=09489c89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports